import { DefaultPlayerConfig } from '@vh/components/vh-types/configs/players/DefaultPlayer.config';
import { VoiceFocusedConfig } from '@vh/components/vh-types/configs/players/VoiceFocusedPlayer.config';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { virtualHumanDataSelector } from '@vh/slices/VirtualHumanSlice';

const vhPlayerConfig = {
  default: DefaultPlayerConfig,
  voice_focused: VoiceFocusedConfig,
};

export const useVHPlayerConfig = () => {
  const vh = useSelector(virtualHumanDataSelector);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const paramsPlayer = /** @type {keyof vhPlayerConfig} */ (
    params.get('player')
  );
  if (
    typeof paramsPlayer === 'string' &&
    vhPlayerConfig.hasOwnProperty(paramsPlayer)
  ) {
    return vhPlayerConfig[paramsPlayer];
  }
  if (vh?.PlayerType && vhPlayerConfig.hasOwnProperty(vh.PlayerType)) {
    return vhPlayerConfig[/** @type {keyof vhPlayerConfig} */ (vh.PlayerType)];
  }
  return vhPlayerConfig.default;
};

// // injectedVhType for when no redux store e.g. in outer app
// export const useInjectedVHPlayerConfig = (
//   /** @type { keyof vhPlayerConfig } */ vhPlayer = 'default'
// ) => {
//   return vhPlayerConfig[vhPlayer];
// };
